import {useTheme} from "@emotion/react";
import Markdown from "@/elements/Markdown";
import {textStyles} from "@/elements/text";
import type {SectionInserts} from "@/generated/api";
import {theme} from "@/styles/theme";
import {
  ContentWrapper,
  FirstLineTitle,
  InsertCardStyled,
  SecondLineTitle,
  Surtitle,
  SurtitleEmojiWrapper,
} from "./styles";

// An insert of a section: an emoji or a surtitle, two parts of a title and a text
type InsertItem = Exclude<SectionInserts["inserts"], boolean>[number];

interface InsertCardProps {
  cardData: InsertItem;
  isOneInsert?: boolean;
}

const InsertCard = ({cardData, isOneInsert}: InsertCardProps) => {
  const {breakpoints} = useTheme();
  return (
    <InsertCardStyled isOneInsert={isOneInsert}>
      <ContentWrapper>
        <SurtitleEmojiWrapper
          style={{marginBottom: cardData.emoji || cardData.surtitle ? 20 : 0}}
        >
          {cardData.emoji && (
            <div style={{marginRight: 16, display: "flex", alignItems: "center"}}>
              {cardData.emoji}
            </div>
          )}
          <Surtitle>{cardData.surtitle}</Surtitle>
        </SurtitleEmojiWrapper>
        {(cardData.first_part_title || cardData.second_part_title) && (
          <div style={{marginBottom: 16}}>
            {cardData.first_part_title && (
              <FirstLineTitle>{cardData.first_part_title}</FirstLineTitle>
            )}
            {cardData.second_part_title && (
              <SecondLineTitle>{cardData.second_part_title}</SecondLineTitle>
            )}
          </div>
        )}
        {cardData?.text && (
          <Markdown styles={{...textStyles({...theme, breakpoints}).bodyRegular}}>
            {cardData?.text}
          </Markdown>
        )}
      </ContentWrapper>
    </InsertCardStyled>
  );
};

export default InsertCard;
